import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import useUserAttribute from '../hooks/useUserAttribute';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CloseableTipAlert({
  getUserAttributes,
  setUserAttribute,
  attributeKey,
  title,
  children
}) {
  const [attributeLoaded, hasAttribute, setHasAttribute] = useUserAttribute(getUserAttributes, setUserAttribute, attributeKey);
  if (!attributeLoaded || hasAttribute) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Alert, {
    marginBlockStart: "400",
    closeable: true,
    type: "info",
    use: "inline",
    onClose: () => setHasAttribute(true),
    children: [title && /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-50",
      children: `${title}: `
    }), children]
  });
}